import {
  SoftwareManagementDeleteSoftwareSetupContractDocument,
  SoftwareManagementDeleteSoftwareSetupContractMutation,
  SoftwareManagementDeleteSoftwareSetupContractMutationVariables,
  SoftwareManagementGetSoftwareSetupsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteSoftwareSetupContract = () => {
  const [deleteSoftwareSetupContract, { loading }] = useMutation(
    SoftwareManagementDeleteSoftwareSetupContractDocument,
    {
      extractorFn: (data: SoftwareManagementDeleteSoftwareSetupContractMutation) =>
        data.softwareManagementMutations.deleteContractSoftwaremanagementSoftwareSetup,
    }
  )

  return {
    deleteSoftwareSetupContract(
      variables: SoftwareManagementDeleteSoftwareSetupContractMutationVariables
    ) {
      return deleteSoftwareSetupContract({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: SoftwareManagementGetSoftwareSetupsDocument,
            variables: {
              ids: [variables.softwareSetupId],
            },
          },
        ],
      })
    },
    loading,
  }
}
